export enum VacayRequestStatus {
  DECLINED = 0,
  PENDING = 1,
  APPROVED = 2,
  UNASSIGNED = 3
}
